/** Narrows `value` and throws the same TypeError the runtime throws when reading `property` off null/undefined. */
export const requirePresent = <T>(value: T | null | undefined, property: string): T => {
  if (value === null) {
    throw new TypeError(`Cannot read properties of null (reading '${property}')`);
  }

  if (value === undefined) {
    throw new TypeError(`Cannot read properties of undefined (reading '${property}')`);
  }

  return value;
};
